import AssociatesReportResult from './ResultPage';

export default AssociatesReportResult;
